const _version = "3.7.2"
function version() {
    return _version
}
export default version
